import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import CreateEVACDeviceProvider from "./baseProviders/createEVACDeviceProvider"
import useContinueEVACDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueEVACDeviceDraft"

interface IContinueEVACDeviceVersionUrlParams {
    deviceRef: string
}

interface IContinueEVACDeviceVersionProviderProps {
    children: ReactNode
}

const ContinueEVACDeviceVersionProvider = ({
    children,
}: IContinueEVACDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueEVACDeviceVersionUrlParams
    >() as IContinueEVACDeviceVersionUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueVersionError,
        attachmentUUID,
    } = useContinueEVACDeviceDraft(urlDeviceRef)

    return (
        <CreateEVACDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueVersionError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={urlDeviceRef}
            canEditManufacturer={false}
            isNewVersion
        >
            {children}
        </CreateEVACDeviceProvider>
    )
}

export default ContinueEVACDeviceVersionProvider
